import React, { ReactElement, FunctionComponent, memo } from 'react'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../utils/PropTypesDefinitions'
import FavoriteItem from '../BaseComponents/Favorites/FavoriteItem'
import LinkProps from '../Link/LinkProps'

export type RelatedContextProps = {
    /** text which is shown below the image */
    label: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /** callback when the user pressed on the image or the text label
     *
     * @TJS-type function
     * */
    onPress?: () => void
    /** the url of the image */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    /** specific type of the favorite item
     *
     * @defaultValue 'DEFAULT'
     * */
    type?: 'PLAYER' | 'TEAM' | 'DEFAULT'
    /** boolean to determine if the favorite icon is filled with yellow color or not */
    isFavorite: boolean
    /** callback when the user presses on the favorite icon
     *
     * @TJS-type function
     * */
    onFavorite: () => void
} & LinkProps &
    TestID

const RelatedContext: FunctionComponent<RelatedContextProps> = ({
    label,
    imageUrl,
    alt,
    type = 'DEFAULT',
    isFavorite,
    href,
    onPress,
    onFavorite,
    testID,
    webRel,
}): ReactElement => {
    return (
        <Grid
            noExpand
            centerHorizontal
            width={62}
            paddingX={3}
            backgroundColor="pearl"
            testID={testID}
        >
            <Grid noExpand marginBottom={3}>
                <FavoriteItem
                    label={label}
                    imageUrl={imageUrl}
                    alt={alt}
                    type={type}
                    onPress={onPress}
                    testID={testID}
                />
            </Grid>
            <Touchable onPress={onFavorite} href={href} webRel={webRel}>
                <FontelloIcon
                    name={isFavorite ? 'favorite-active' : 'favorite'}
                    fontSize={17}
                    color={isFavorite ? 'ORANGE' : 'keshi-3'}
                />
            </Touchable>
        </Grid>
    )
}

export default memo(RelatedContext)
